import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { catchError, debounceTime, distinctUntilChanged, filter, map, switchMap, tap } from 'rxjs/operators';
import { CampaignModel } from 'src/app/models/CampaignModel';
import { CampaignUDF1StepModel } from 'src/app/models/CampaignUDF1StepModel';
import { RequestModel } from 'src/app/models/RequestModel';
import { TreesViewModel } from 'src/app/models/TreesViewModel';
import { UdfControlType } from 'src/app/models/UdfControlType';
import { BingService } from 'src/app/services/bing.service';
import { LogicService } from 'src/app/services/logic.service';
import { TestFill } from 'src/app/utils/TestFill';
import { AzureMapsService } from 'src/app/services/azure-maps-service';
import { ILookupItem, LookupItem } from 'src/app/models/LookupItem';
import { Observable, of } from 'rxjs';
import { NgbTypeaheadSelectItemEvent } from '@ng-bootstrap/ng-bootstrap';

declare var Microsoft: any;

@Component({
    selector: 'app-step1',
    templateUrl: './step1.component.html',
    styleUrls: ['./step1.component.css']
})
export class Step1Component implements OnInit {
    udfForms: FormArray = null;
    udfs: CampaignUDF1StepModel[] = null;

    phoneTypes = ['Mobile', 'Home', 'Work'];

    get model(): TreesViewModel { return this._model; }
    @Input() set model(value: TreesViewModel) {
        this._model = value;
        this.campaign = value.campaign;
        this.request = value.request;
        if (value !== null) {
            this.udfs = this.campaign.udf1;
        }
    }
    request: RequestModel = null;
    campaign: CampaignModel = null;

    private _model: TreesViewModel = null;

    requestForm: FormGroup = null;
    neig: string = '';
    neigMess: string = null;

    isVerifyEnabled = true;

    constructor(private fb: FormBuilder,
        // private bingService: BingService,
        private azureMapsService: AzureMapsService,
        public logic: LogicService,
        public cdr: ChangeDetectorRef) {
    }

    ngOnInit(): void {
        this.initForm(this.request);
    }

    private initForm(model: RequestModel, n = 0): void {
        this.requestForm = this.fb.group({
            firstName: [model.firstName, [Validators.required, Validators.maxLength(32)]],
            lastName: [model.lastName, [Validators.required, Validators.maxLength(32)]],
            organization: [model.organization, Validators.maxLength(32)],
            email: [model.email, [Validators.required, Validators.email, Validators.maxLength(64)]],
            primaryPhone: [model.primaryPhone, [Validators.required, Validators.maxLength(16)]],
            primaryPhoneType: [model.primaryPhoneType, [Validators.required]],
            alternativePhone: [model.alternativePhone, [Validators.maxLength(16)]],
            alternativePhoneType: [model.alternativePhoneType],
            mailAddress: [model.mailAddress, [Validators.required, Validators.maxLength(32)]],
            mailCity: [model.mailCity, [Validators.required, Validators.maxLength(32)]],
            mailState: [model.mailState, [Validators.required]],
            mailZip: [model.mailZip, [Validators.required, Validators.minLength(5)]],
            sameAsMail: [model.sameAsMail],
            plantingAddress: [model.plantingAddress, [Validators.required, Validators.maxLength(32)]],
            plantingCity: [model.plantingCity, [Validators.required, Validators.maxLength(32)]],
            plantingState: [model.plantingState, [Validators.required]],
            plantingZip: [model.plantingZip, [Validators.required, Validators.minLength(5)]],
            // plantingZip: [model.plantingZip, [Validators.required, Validators.pattern('[0-9]{5}')]],
            neededTreeship: [model.neededTreeship],
            ifTreeshipParagraph: [model.ifTreeshipParagraph]

        });
        // this.requestForm.controls.plantingAddress.valueChanges
        //     .pipe(debounceTime(1000))
        //     .subscribe(v => {
        //         this.geocode();
        //     });

        this.requestForm.controls.neededTreeship.valueChanges.subscribe(checked => {
            if (checked) {
                this.requestForm.controls.ifTreeshipParagraph.setValidators([Validators.required]);
            } else {
                this.requestForm.controls.ifTreeshipParagraph.setValidators(null);
            }
            this.requestForm.controls.ifTreeshipParagraph.updateValueAndValidity();
        });

        this.requestForm.controls.alternativePhone.valueChanges
            .pipe(debounceTime(30))
            .subscribe(phone => {
                if (phone !== null) {
                    this.requestForm.controls.alternativePhoneType.setValidators([Validators.required]);
                } else {
                    this.requestForm.controls.alternativePhoneType.setValidators(null);
                    this.requestForm.controls.alternativePhoneType.setValue('Mobile');
                }
                this.requestForm.controls.alternativePhoneType.updateValueAndValidity();
            });

        this.requestForm.controls.sameAsMail.valueChanges.subscribe(checked => {
            if (checked) {
                document.getElementById("plantingAddress").style.backgroundColor = "#e9ecef";
                this.requestForm.controls.plantingAddress.reset();
                this.requestForm.controls.plantingAddress.setValue(this.requestForm.controls.mailAddress.value);
                this.requestForm.controls.plantingCity.setValue(this.requestForm.controls.mailCity.value);
                this.requestForm.controls.plantingState.setValue(this.requestForm.controls.mailState.value);
                this.requestForm.controls.plantingZip.setValue(this.requestForm.controls.mailZip.value);
                // this.requestForm.controls.plantingAddress.disable();
                // this.requestForm.controls.plantingCity.disable();
                // this.requestForm.controls.plantingState.disable();
                // this.requestForm.controls.plantingZip.disable();


            }
            else {
                document.getElementById("plantingAddress").style.backgroundColor = "white";
                // this.requestForm.controls.plantingAddress.enable();
                // this.requestForm.controls.plantinCity.enable();
                // this.requestForm.controls.plantingState.enable();
                // this.requestForm.controls.plantingZip.enable();

            }
            // this.requestForm.controls.plantingAddress.updateValueAndValidity();
            // this.requestForm.controls.plantingCity.updateValueAndValidity();
            // this.requestForm.controls.plantingState.updateValueAndValidity();
            // this.requestForm.controls.plantingZip.updateValueAndValidity();

        });

        this.requestForm.controls.plantingAddress.valueChanges.subscribe(a => {
            this.request.neighborhoodDesc = null;
            this.request.neighborhoodId = -1;
            this.neigMess = null;
            this.isVerifyEnabled = true;
        })
        this.requestForm.controls.plantingCity.valueChanges.subscribe(a => {
            this.request.neighborhoodDesc = null;
            this.request.neighborhoodId = -1;
            this.neigMess = null;
            this.isVerifyEnabled = true;
        })
        this.requestForm.controls.plantingState.valueChanges.subscribe(a => {
            this.request.neighborhoodDesc = null;
            this.request.neighborhoodId = -1;
            this.neigMess = null;
            this.isVerifyEnabled = true;
        })
        this.requestForm.controls.plantingZip.valueChanges.subscribe(a => {
            this.request.neighborhoodDesc = null;
            this.request.neighborhoodId = -1;
            this.neigMess = null;
            this.isVerifyEnabled = true;
        })
        if (n !== 0) {
            return;
        }
        this.udfForms = new FormArray([]);
        for (const udf of this.campaign.udf1) {
            let control: FormControl;
            if (udf.uDFIControlType === UdfControlType.CheckBox) {
                control = new FormControl(udf.value);
            } else {
                control = new FormControl(udf.value);
                if (udf.uDFIsRequired) {
                    control.setValidators([Validators.required, Validators.maxLength(64)]);
                }
            }
            this.udfForms.push(control);
        }
    }

    altPhoneClick() {
        // let phone = this.requestForm.controls.alternativePhone.value;

        // if (phone !== null && phone !== '') {
        //     this.requestForm.controls.alternativePhoneType.setValidators([Validators.required]);
        // } else {
        //     this.requestForm.controls.alternativePhoneType.setValidators(null);
        //     this.requestForm.controls.alternativePhoneType.setValue(null);
        // }
        // this.requestForm.controls.alternativePhoneType.updateValueAndValidity();

    }

    get f(): any { return this.requestForm.controls; }

    udfDrops(i: number): string[] {
        let a = [];
        if (this.udfs[i].uDFDropDownValues) {
            a = this.udfs[i].uDFDropDownValues.split(',');
        }
        return a;
    }
    saveRequest(): void {
        // this.model = {...this.model, ...this.requestForm.value};
        this.updateModel(this.request, this.requestForm);
        for (let i = 0; i < this.campaign.udf1.length; i++) {
            const udf = this.campaign.udf1[i];
            udf.value = this.udfForms.controls[i].value;
        }

    }

    setTouched(): void {
        this.requestForm.markAllAsTouched();
    }
    private updateModel(model: RequestModel, form: FormGroup): void {
        model.firstName = form.controls.firstName.value;
        model.lastName = form.controls.lastName.value;
        model.organization = form.controls.organization.value;
        model.email = form.controls.email.value;
        model.primaryPhone = form.controls.primaryPhone.value;
        model.primaryPhoneType = form.controls.primaryPhoneType.value;
        model.alternativePhone = form.controls.alternativePhone.value;
        model.alternativePhoneType = form.controls.alternativePhoneType.value;
        model.mailAddress = form.controls.mailAddress.value;
        model.mailCity = form.controls.mailCity.value;
        model.mailState = form.controls.mailState.value;
        model.mailZip = form.controls.mailZip.value;
        model.sameAsMail = form.controls.sameAsMail.value;
        model.plantingAddress = form.controls.plantingAddress.value;
        model.plantingCity = form.controls.plantingCity.value;
        model.plantingState = form.controls.plantingState.value;
        model.plantingZip = form.controls.plantingZip.value;
        model.neededTreeship = form.controls.neededTreeship.value;
        model.ifTreeshipParagraph = form.controls.ifTreeshipParagraph.value;

    }

    isDitry(): boolean {
        return this.requestForm.dirty;
    }
    isValid(): boolean {
        return this.requestForm.valid && this.udfForms.status === 'VALID'
            && this.request.neighborhoodId !== -1;
    }

    geocode(): void {
        let address;
        // if (this.requestForm.controls.sameAsMail.value) {
        //     address = `${this.requestForm.controls.mailAddress.value}, `;
        //     address += `${this.requestForm.controls.mailCity.value}, `;
        //     address += `${this.requestForm.controls.mailState.value} `;
        //     address += `${this.requestForm.controls.mailZip.value}`;

        // }
        // else {
        address = `${this.requestForm.controls.plantingAddress.value}, `;
        address += `${this.requestForm.controls.plantingCity.value}, `;
        address += `${this.requestForm.controls.plantingState.value} `;
        address += `${this.requestForm.controls.plantingZip.value}`;

        // }
        if (address.includes('null')) {
            return;
        }
        // this.bingService.getLocation(address)
        //     .subscribe(response => this.onGetBing(response));

    }

    onGetBing = (response: any) => {
        let neig: string = null;
        this.request.neighborhoodDesc = null;
        this.request.neighborhoodId = -1;
        this.neigMess = null;

        const a = response.resourceSets[0].resources[0].address.neighborhood;
        if (response && response.resourceSets && response.resourceSets.length > 0) {
            const set = response.resourceSets[0];
            if (set.resources && set.resources.length > 0) {
                neig = set.resources[0].address.neighborhood;
                // (document.getElementById('neighborhood') as HTMLInputElement).value = neig || '';
                if (neig) {
                    neig = neig == 'Stapleton' ? 'Central Park' : neig;
                    const neighborhood = CampaignModel.findNeighborhood(neig, this.campaign.neighborhoods);
                    this.request.neighborhoodDesc = neig;
                    if (neighborhood) {
                        this.request.isTargetNeighborhood = neighborhood.isTargetNeighborhood;
                        this.request.neighborhoodId = neighborhood.neighborhoodId;
                        this.request.distributionId = neighborhood.distributionId;
                    }
                    else {
                        this.neigMess = "Your neighborhood is not eligible for this program at this time. There may be other options though - you may email us questions at info@theparkpeople.org.";
                    }
                }
                else {
                    this.neigMess = "Your neighborhood is not eligible for this program at this time. There may be other options though - you may email us questions at info@theparkpeople.org.";
                }

            }
        }
        this.isVerifyEnabled = false;
    }

    ngAfterViewInit(): void {

        var h = document.getElementById("alternativePhone").offsetHeight;



        // Microsoft.Maps.loadModule('Microsoft.Maps.Search', {
        //     callback: onLoadSerch,
        //     errorCallback: onErrorBingMaps,
        //     credentials: 'AloHboXEDiUMvVTjguKYlZSwCcsdxFCE16FU8Rt2Xcxylw2gCzzdjnTnOnSvqqIa'

        //     // credentials: 'AjtUzWJBHlI3Ma_Ke6Qv2fGRXEs0ua5hUQi54ECwfXTiWsitll4AkETZDihjcfeI' // from stackoverflow
        // });
        // function onLoadSerch(){
        //     let searchManager = new Microsoft.Maps.Search.SearchManager();
        // }

        // Microsoft.Maps.loadModule('Microsoft.Maps.AutoSuggest', {
        //     callback: onLoadBingMaps,
        //     errorCallback: onErrorBingMaps,
        //     // credentials: this.campaign.bi // 'AloHboXEDiUMvVTjguKYlZSwCcsdxFCE16FU8Rt2Xcxylw2gCzzdjnTnOnSvqqIa'
        //     credentials: 'AloHboXEDiUMvVTjguKYlZSwCcsdxFCE16FU8Rt2Xcxylw2gCzzdjnTnOnSvqqIa'

        //     // credentials: 'AjtUzWJBHlI3Ma_Ke6Qv2fGRXEs0ua5hUQi54ECwfXTiWsitll4AkETZDihjcfeI' // from stackoverflow
        // });

        function onLoadBingMaps(): void {
            const options = { maxResults: 5 };
            const manager = new Microsoft.Maps.AutosuggestManager(options);
            const manager2 = new Microsoft.Maps.AutosuggestManager(options);
            manager.attachAutosuggest('#mailAddress', '#searchBoxContainer', selectedSuggestionBingMaps);
            manager2.attachAutosuggest('#plantingAddress', '#searchBoxContainer2', selectedSuggestionBingMaps2);
            document.getElementById("mailAddress").style.height = "25px";
            document.getElementById("mailAddress").style.width = '96%'
            document.getElementById("plantingAddress").style.height = "25px";
            document.getElementById("plantingAddress").style.width = '96%'

            // var e = document.getElementById("mailAddress");
            // document.getElementById("mailAddress").classList.add("form-control");
        }


        function onErrorBingMaps(message): void {
            alert(message);
        }

        const that = this;
        function selectedSuggestionBingMaps(suggestionResult): void {
            // that.requestForm.get('mailAddress').setValue(suggestionResult.address.formattedAddress || '');
            that.requestForm.get('mailAddress').setValue(suggestionResult.address.addressLine || '');
            that.requestForm.get('mailCity').setValue(suggestionResult.address.locality || '');
            that.requestForm.get('mailState').setValue(suggestionResult.address.adminDistrict || '');
            that.requestForm.get('mailZip').setValue(suggestionResult.address.postalCode || '');

            // that.requestForm.get('plantingAddress').setValue(suggestionResult.address.formattedAddress || '');

            if (that.requestForm.get('sameAsMail').value) {
                that.isVerifyEnabled = true;
                that.requestForm.get('plantingAddress').setValue(suggestionResult.address.addressLine || '');
                that.requestForm.get('plantingCity').setValue(suggestionResult.address.locality || '');
                that.requestForm.get('plantingState').setValue(suggestionResult.address.adminDistrict || '');
                that.requestForm.get('plantingZip').setValue(suggestionResult.address.postalCode || '');
            }

            if (that.requestForm.get('sameAsMail2').value) {
                that.request.billingAddress = suggestionResult.address.addressLine || '';
                that.request.billingCity = suggestionResult.address.locality || '';
                that.request.billingState = suggestionResult.address.adminDistrict || '';
                that.request.billingZip = suggestionResult.address.postalCode || ''
            }
            // (document.getElementById('mailAddress') as HTMLInputElement).value = suggestionResult.address.addressLine || '';
            // (document.getElementById('mailCity') as HTMLInputElement).value = suggestionResult.address.locality || '';
            // (document.getElementById('mailState') as HTMLInputElement).value = suggestionResult.address.adminDistrict || '';
            // (document.getElementById('mailZip') as HTMLInputElement).value = suggestionResult.address.postalCode || '';
            // that.request.mailAddress2 = suggestionResult.address.addressLine || '';
            // that.request.plantingAddress2 = that.request.mailAddress2;
            // setTimeout(() => {
            //     (document.getElementById('plantingAddress') as HTMLInputElement).value =
            //     (document.getElementById('mailAddress') as HTMLInputElement).value  || '';
            // }, 1);
            setTimeout(() => {
                var h = document.getElementById("alternativePhone").style.height;
                (document.getElementById('mailAddress') as HTMLInputElement).value = suggestionResult.address.addressLine || '';
            }, 1);
        }

        function selectedSuggestionBingMaps2(suggestionResult): void {

            that.isVerifyEnabled = true;
            that.requestForm.get('plantingAddress').setValue(suggestionResult.address.addressLine || '');
            that.requestForm.get('plantingCity').setValue(suggestionResult.address.locality || '');
            that.requestForm.get('plantingState').setValue(suggestionResult.address.adminDistrict || '');
            that.requestForm.get('plantingZip').setValue(suggestionResult.address.postalCode || '');

            // (document.getElementById('mailAddress') as HTMLInputElement).value = suggestionResult.address.addressLine || '';
            // (document.getElementById('mailCity') as HTMLInputElement).value = suggestionResult.address.locality || '';
            // (document.getElementById('mailState') as HTMLInputElement).value = suggestionResult.address.adminDistrict || '';
            // (document.getElementById('mailZip') as HTMLInputElement).value = suggestionResult.address.postalCode || '';
            // that.request.plantingAddress2 = suggestionResult.address.addressLine || '';
            setTimeout(() => {
                (document.getElementById('plantingAddress') as HTMLInputElement).value = suggestionResult.address.addressLine || '';
            }, 1);
        }

    }


    // New Azure Maos
    //

    searchQuery = '';

    searchQuery2: LookupItem = new LookupItem();

    results: any;
    searching = false;
    searchFailed = false;
    results2: LookupItem[] = [];
    lookupAddress = (text$: Observable<string>) =>
        text$.pipe(
            filter(value => value.length >= 3),
            debounceTime(300),
            //distinctUntilChanged(),
            tap(() => this.searching = true),
            switchMap(term =>
                this.azureMapsService.lookAddress(term as string).pipe(

                    tap(r => {
                        this.searchFailed = false;
                        this.results = r;
                    }),
                    map(response => this.converToLookup(response)),
                    catchError(() => {
                        this.searchFailed = true;
                        return of([]);
                    }))
            ),
            tap(() => this.searching = false)
        )


    converToLookup(r: any): any[] {
        let res: LookupItem[] = [];

        let i = 0
        for (const item of r.results) {
            let look = new LookupItem();
            look.id = i;
            look.text = item.address?.freeformAddress;
            look.text2 = item.address?.neighbourhood || '';
            look.pointer = item;


            res.push(look);
            i++;
        }
        this.results2 = res;
        return res;
    }

    // formatter(result: ILookupItem): string {
    //     return result.text;
    // }
    formatterr(result: ILookupItem): string {
        if (typeof result === "string") {
            return result;
        }
        return result.text;
    }
    formatter(query: LookupItem): string {
        if (typeof query === "string") {
            return query;
        }
        const address = query.pointer.address;
        const line = `${address.streetNumber || ''} ${address.streetName || ''}`
        return line;
    }

    selectAddress(event: NgbTypeaheadSelectItemEvent) {
        const query = event.item as LookupItem;
        const address = query.pointer.address;
        const line = `${address.streetNumber || ''} ${address.streetName || ''}`

        var a = this.requestForm.get('mailAddress').value;
        // this.requestForm.get('mailAddress').setValue(line);
        this.requestForm.get('mailCity').setValue(address.municipality || '');
        this.requestForm.get('mailState').setValue(address.countrySubdivisionName || '');
        this.requestForm.get('mailZip').setValue(address.postalCode || '');
        setTimeout(() => {
            this.requestForm.get('mailAddress').setValue(line);
        }, 10);

        if (this.requestForm.get('sameAsMail').value) {
            this.isVerifyEnabled = true;
            this.requestForm.get('plantingAddress').setValue(line);
            this.requestForm.get('plantingCity').setValue(address.municipality || '');
            this.requestForm.get('plantingState').setValue(address.countrySubdivisionName || '');
            this.requestForm.get('plantingZip').setValue(address.postalCode || '');
        }

        if (this.request.sameAsMail2) {
            this.request.billingAddress = line || '';
            this.request.billingCity = address.municipality || '';
            this.request.billingState = address.countrySubdivisionName || '';
            this.request.billingZip = address.postalCode || ''
        }

        const streetNumber = address.streetNumber || '';
        const street = address.streetName || '';
        const city = address.municipality || '';
        const state = address.countrySubdivisionCode || '';
        const zip = address.postalCode || '';
    }

    selectAddress2(event: NgbTypeaheadSelectItemEvent) {
        const query = event.item as LookupItem;
        const address = query.pointer.address;
        const line = `${address.streetNumber || ''} ${address.streetName || ''}`

        this.isVerifyEnabled = true;
        //this.requestForm.get('plantingAddress').setValue(line);
        this.requestForm.get('plantingCity').setValue(address.municipality || '');
        this.requestForm.get('plantingState').setValue(address.countrySubdivisionName || '');
        this.requestForm.get('plantingZip').setValue(address.postalCode || '');
        setTimeout(() => {
            this.requestForm.get('plantingAddress').setValue(line);
        }, 10);
    }

    getNeig() {
        let a = this.requestForm.get('plantingAddress').value;
        let s = this.requestForm.get('plantingState').value;

        let address = `${this.requestForm.get('plantingAddress').value}, `;
        address += `${this.requestForm.get('plantingCity').value}, `;
        address += `${this.requestForm.get('plantingState').value} `;
        address += `${this.requestForm.get('plantingZip').value}`;
        this.request.neighborhoodDesc = null;
        this.request.neighborhoodId = -1;


        if (address.includes('null')) {
            return;
        }
        if (s == 'Colorado') {
            this.azureMapsService.lookAddress(address as string)
                .subscribe(response => {
                    let neig = '';
                    if (response && response.results && response.results.length > 0) {
                        const r = response.results[0];
                        neig = r.address?.neighbourhood || ''
                    }
                    this.validateNeig(neig);
                });
        }
        else {
            this.validateNeig('');
        }

    }

    getNeigGeo() {
        let line = this.requestForm.get('plantingAddress').value;
        let city = this.requestForm.get('plantingCity').value;
        let state = this.requestForm.get('plantingState').value;
        let postal = this.requestForm.get('plantingZip').value;

        let address = `${this.requestForm.get('plantingAddress').value}, `;
        address += `${this.requestForm.get('plantingCity').value}, `;
        address += `${this.requestForm.get('plantingState').value} `;
        address += `${this.requestForm.get('plantingZip').value}`;
        this.request.neighborhoodDesc = null;
        this.request.neighborhoodId = -1;


        if (state == 'Colorado') {
            this.azureMapsService.geocode(line, city, state, postal)
                .subscribe(response => {
                    let neig = '';
                    if (response && response.features && response.features.length > 0) {
                        // const feature = response.features[0];
                        let address = response.features[0].properties.address || {};
                        neig = address.neighborhood || '';
                        let street = address.addressLine || '';
                        if (street != '') {
                            this.requestForm.get('plantingAddress').setValue(street);
                        }
                    }
                    this.validateNeig(neig);
                });
        }
        else {
            this.validateNeig('');
        }

    }

    validateNeig(neig: string) {
        this.request.neighborhoodDesc = null;
        this.request.neighborhoodId = -1;
        this.neigMess = null;


        if (neig != '') {
            neig = neig == 'Stapleton' ? 'Central Park' : neig;
            const neighborhood = CampaignModel.findNeighborhood(neig, this.campaign.neighborhoods);
            this.request.neighborhoodDesc = neig;
            if (neighborhood) {
                this.request.isTargetNeighborhood = neighborhood.isTargetNeighborhood;
                this.request.neighborhoodId = neighborhood.neighborhoodId;
                this.request.distributionId = neighborhood.distributionId;
            }
            else {
                this.neigMess = "Your neighborhood is not eligible for this program at this time. There may be other options though - you may email us questions at info@theparkpeople.org.";
            }
        }
        else {
            this.neigMess = "Your neighborhood is not eligible for this program at this time. There may be other options though - you may email us questions at info@theparkpeople.org.";
        }
        this.isVerifyEnabled = false;

    }

    //   geocode(){
    //     const BingMapsKey = '';
    //     const geocodeRequest = 'http://dev.virtualearth.net/REST/v1/Locations?countryRegion=US&addressLine=852%20S.%20Jason%20St%2C%20Denver%2C%20Colorado%2080223&key=AloHboXEDiUMvVTjguKYlZSwCcsdxFCE16FU8Rt2Xcxylw2gCzzdjnTnOnSvqqIa&inclnb=1&jsonp=GeocodeCallback';
    //     // var geocodeRequest = "http://dev.virtualearth.net/REST/v1/Locations?query="
    //     // + encodeURIComponent(query)
    //     // + "&jsonp=GeocodeCallback" //&key="
    //     // // + BingMapsKey;

    //     this.CallRestService(geocodeRequest);
    // }
    // CallRestService(request) {
    //     var script = document.createElement("script");
    //     script.setAttribute("type", "text/javascript");
    //     script.setAttribute("src", request);
    //     document.body.appendChild(script);
    // }
    // document.GeocodeCallback = function() {
    //     alert('ffgf');
    // }

    // testonly
    //
    fill(): void {
        const testfill = new TestFill();
        testfill.fillRequest(this.request);
        this.initForm(this.request, 1);
        this.cdr.detectChanges();
    }
}
